import React from 'react';
import { ButtonTypes } from 'src/constants/metrics';
import { useMetrics } from 'src/utils';

interface ImageWrapperProps {
  imageElement: JSX.Element,
  displayImage: () => void,
}
const ImageWrapper: React.FC<ImageWrapperProps> = (
  { imageElement, displayImage },
) => {
  const { clickMetric } = useMetrics();
  return (
    <button
      data-testid="carousel-wrapper-button"
      onClick={() => {
        clickMetric({
          metricName: ButtonTypes.imageCarouselOpen,
        });
        displayImage();
      }}
      type="button"
      className="cursor-pointer border-0 bg-transparent p-0"
    >
      {imageElement}
    </button>
  );
};
export default ImageWrapper;
